export default class BBDO_Select {
	static initClass() {
		this.prototype.$el = null;
		this.prototype.$placeholder = null;
		this.prototype.$options = null;
		this.prototype.$option = null;
		this.prototype.$real_select = null;
		this.prototype.$select_animating = false;
		this.prototype.$animatin_speed = 200;
		this.prototype.$scrollbar = null;
	}

	constructor($el) {
		this.$el = $el;
		this.$placeholder = $('.select__placeholder', this.$el);
		this.$options = $('.select__options', this.$el);
		this.$option = $('.select__option', this.$el);
		this.$real_select = this.$el.find('select');
		this.init_events();
	}

	init_events() {
		this.$scrollbar = new IScroll(this.$options[0], {
			scrollbars: true,
			mouseWheel: true,
			interactiveScrollbars: true,
			fadeScrollbars: false
		}
		);
		this.$placeholder.on('click', e => {
			e.stopPropagation();
			if (!this.$el.hasClass('is-open')) {
				return this.open_select();
			} else {
				return this.close_select();
			}
		});

		this.$option.on('mouseover', e => {
			e.stopPropagation();
			if (this.$el.hasClass('is-open') && !this.$select_animating && !$(e.target).hasClass('is-active')) {
				this.$option.removeClass('is-active');
				return $(e.target).addClass('is-active');
			}
		});

		this.$option.on('click', e => {
			console.log('click');
			e.preventDefault();
			e.stopPropagation();

			const me = $(e.target);
			const value = me.attr('data-value');
			const text = me.text();

			this.$option.removeClass('is-selected');
			me.addClass('is-active is-selected');

			this.$placeholder.find('span').text(text);
			this.$placeholder.attr('data-value', value);

			this.$real_select.find('option').prop('selected', false);
			this.$real_select.find(`option[value="${value}"]`).prop('selected', true);
			this.$real_select.change();
			this.$real_select.parent().parent().removeClass('error');
			return this.close_select();
		});

		$(document).on('click', e => {
			if (!$(e.target).is('.select')) {
				return this.close_select();
			}
		});

		return $('.touch').find(this.$real_select).on('change', e => {
			return this.$placeholder.find('span').text($(e.target).find(`option[value="${$(e.target).val()}"]`).text());
		});
	}


	close_select() {
		this.$el.removeClass('has-border');
		this.$select_animating = true;
		return this.$options.stop().slideUp(this.$animatin_speed, () => {
			this.$el.removeClass('is-open');
			this.$option.removeClass('is-active');
			$('.select__option.is-selected', this.$el).addClass('is-active');
			return this.$select_animating = false;
		});
	}

	open_select() {
		$('.select').not(this.$el).find('.select__options').css('z-index', 4);
		this.$options.css('z-index', 5);
		$('.select__options').stop().slideUp(this.$animatin_speed);
		$('.select').removeClass('is-open has-border');
		this.$options.stop().slideDown(this.$animatin_speed, () => {
			return this.$scrollbar.refresh();
		});
		return this.$el.addClass('is-open has-border');
	}
}

